module.exports = __webpack_public_path__ + "img/Certificate_pic02.a77a738b.png";